import { render, staticRenderFns } from "./FrontpageCard.vue?vue&type=template&id=e9b3b19e&scoped=true"
import script from "./FrontpageCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./FrontpageCard.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FrontpageCard.vue?vue&type=style&index=0&id=e9b3b19e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b3b19e",
  null
  
)

export default component.exports